import React from 'react';
import LinearIndeterminate from '../../../components/LinearIndeterminate/LinearIndeterminate';
import language from '../../../config/es';

// Propiedades comunes de las tablas con paginacion en servidor
export const getServerTableProps = ({
  data,
  scrollHeight,
  onChangeRowsPerPage,
  onChangePage,
}) => ({
  fixedHeader: true,
  fixedHeaderScrollHeight: scrollHeight,
  dense: true,
  highlightOnHover: true,
  pagination: true,
  paginationServer: true,
  paginationComponentOptions: language.messages.paginationOptions,
  progressPending: data.pendingData,
  progressComponent: <LinearIndeterminate />,
  persistTableHead: true,
  paginationTotalRows: data.totalRows,
  onChangeRowsPerPage,
  onChangePage,
});
